export default "__VITE_ASSET__0852a232__"